import React from 'react';
import { ErrorWrapper } from './styles';
import { Typography } from '@mui/material';
import { type FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { type SerializedError } from '@reduxjs/toolkit';
import { useTranslation } from 'react-i18next';

type ShowErrorProps = {
  error: FetchBaseQueryError | SerializedError | Error | undefined;
  additionalText?: string;
};

export const ShowError = ({ error, additionalText }: ShowErrorProps) => {
  const { t } = useTranslation('filters');

  return (
    <ErrorWrapper>
      <Typography variant="h1" color="error">
        {t('status.values.error')}
      </Typography>
      {additionalText && <Typography>{additionalText}</Typography>}
      <Typography component="code">{JSON.stringify(error, null, 2)}</Typography>
    </ErrorWrapper>
  );
};
